// extracted by mini-css-extract-plugin
module.exports = {"shareSec":"ProfileShare_shareSec__3gZo_"};